import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const WITHOUT = ['Spending hours preparing every class', 'Searching several websites for ideas', 'Saving disconnected sequences', 'Repeating the same familiar flows', 'Struggling with mixed-level groups', 'Keeping resources scattered everywhere', 'Arriving at class still feeling uncertain'];
const WITH = ['Have your next class ready in minutes', 'Access structured, professional sequences', 'Find every teaching resource in one place', 'Adapt classes for different experience levels', 'Use clear pose guidance and teaching cues', 'Track student development professionally', 'Walk into every class prepared'];
export function Comparison() {
  return <section aria-labelledby="comparison-title" className="w-full bg-ivory px-4 py-10 sm:px-6" data-id="element-35" data-mp="28wgk4ge8rcet">
      <div className="mx-auto max-w-4xl" data-id="element-36" data-mp="9lff7kludmnm">
        <h2 id="comparison-title" className="text-center font-head text-xl font-extrabold uppercase leading-tight text-charcoal sm:text-3xl" data-id="element-37" data-mp="eiz033d1oxoj">
          Your next class can begin with another blank page...
          <span className="mt-1 block text-brand" data-id="element-38" data-mp="1h8xtqnrygfzy">
            Or you can have a complete system ready.
          </span>
        </h2>

        <div className="mt-6 grid gap-3 md:grid-cols-2" data-id="element-39" data-mp="1d8nhitdkktcn">
          <div className="rounded-2xl border border-urgent/25 bg-urgent/5 p-4" data-id="element-40" data-mp="18a3tmnff17hn">
            <h3 className="font-head text-sm font-bold uppercase tracking-wide text-urgent sm:text-base" data-id="element-41" data-mp="2503ad55pzcbb">
              Without Yoga Teaching Vault™
            </h3>
            <ul className="mt-2 space-y-1.5" data-id="element-42" data-mp="20vvgyuobh86r">
              {WITHOUT.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-charcoal" data-id="element-43" data-mp="1vx267a0ezvaa">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-urgent" aria-hidden="true" data-id="element-44" data-mp="kjzzd6o4ak3b" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-sage/30 bg-sage/5 p-4" data-id="element-45" data-mp="h1amqfw9vmzv">
            <h3 className="font-head text-sm font-bold uppercase tracking-wide text-sage sm:text-base" data-id="element-46" data-mp="gzzfg63mbx40">
              With Yoga Teaching Vault™
            </h3>
            <ul className="mt-2 space-y-1.5" data-id="element-47" data-mp="80m7xiz21ilx">
              {WITH.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-charcoal" data-id="element-48" data-mp="cz5wzs8y3aii">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-49" data-mp="3217pjjsyyxh" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}